import { Directive, HostListener } from '@angular/core';
import { NgControl, Validators } from '@angular/forms';

@Directive({
  selector: '[zipValidatorMask]'
})
export class ZipValidatorMaskDirective {

  constructor(public ngControl: NgControl) { }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    // Remove all non-digit characters
    let numericValue = value.replace(/\D/g, '').slice(0, 5);

    // console.log('Numeric value: ', numericValue);

    // Update the input value with the formatted value
    this.ngControl.control.setValue(numericValue);

    // Adjust the validation
    this.adjustValidation(numericValue);
  }

  adjustValidation(value: string) {
    // Regular expression to match the phone number with optional extension
    let regex = /^(?:\d{5})?$/;
    let isValid = regex.test(value);

    // Apply validation conditionally based on the match result
    this.ngControl.control.setValidators(isValid ? null : Validators.pattern(regex));
    this.ngControl.control.updateValueAndValidity();
  }
}